export type WalletDesignLayout = 'artwork' | 'centered_logo' | 'colors_only';
export type WalletDesignRotation = 0 | 90 | 180 | 270;

export interface WalletDesignPage {
  index: number;
  image: string;
  width: number;
  height: number;
  back_side: boolean;
  background_color: string;
  accent_color: string;
  text_color: string;
  elements: { [rotation: string]: [number, number, number, number] };
}

export interface WalletDesignAnalysis {
  page_count: number;
  suggested_page: number;
  pages: WalletDesignPage[];
}

export interface WalletDesignSettings {
  page: number;
  rotation: WalletDesignRotation;
  layout: WalletDesignLayout;
  zoom: number;
  background_color: string;
  text_color: string;
}

export interface WalletDesign extends WalletDesignSettings {
  id: number;
  strip_url: string;
  square_logo_url: string;
}

export const WALLET_DESIGN_ROTATIONS: WalletDesignRotation[] = [0, 90, 180, 270];

export const WALLET_DESIGN_LAYOUTS: { value: WalletDesignLayout, label: string, hint: string }[] = [
  { value: 'artwork', label: 'Motiv', hint: 'Ausschnitt der Karte rund um das Logo' },
  { value: 'centered_logo', label: 'Logo auf Farbe', hint: 'Logo mittig auf der Hintergrundfarbe' },
  { value: 'colors_only', label: 'Nur Farben', hint: 'Kein Bildstreifen, nur Hintergrund- und Textfarbe' }
];
